import { MOUSE_POINTER_ICON_SVG_SOURCE } from "@/shared/ui/mousePointerIcon";
import banIconSource from "bootstrap-icons/icons/ban.svg?raw";
import pauseIconSource from "bootstrap-icons/icons/pause-fill.svg?raw";

const BASE_MP_SLOT_WIDTH_PX = 32;
const EXTRA_MP_SLOT_ICON_WIDTH_PX = 8;
const MULTI_MP_SLOT_ICON_OVERLAP_PX = -11;

export interface MpSlotIndicatorOptions {
  readonly requiredMp?: number;
  readonly blockedOverlay?: boolean;
  readonly pauseOverlay?: boolean;
}

export function createMpSlotIndicator(
  options?: MpSlotIndicatorOptions,
): HTMLDivElement {
  const iconCount = Math.max(1, Math.trunc(options?.requiredMp ?? 1));
  const indicator = document.createElement("div");
  indicator.className = "hover-idle-mp-slot";
  indicator.dataset.disabled = "false";
  if (options?.blockedOverlay === true) {
    indicator.dataset.mpAssigned = "false";
    indicator.dataset.mpOperative = "false";
    indicator.dataset.mpBlocked = "false";
    indicator.dataset.blocked = "false";
  }
  if (iconCount > 1) {
    indicator.dataset.requiredMp = String(iconCount);
    indicator.style.setProperty(
      "--hover-idle-mp-slot-required-width",
      `${BASE_MP_SLOT_WIDTH_PX + (iconCount - 1) * EXTRA_MP_SLOT_ICON_WIDTH_PX}px`,
    );
    indicator.style.setProperty(
      "--hover-idle-mp-slot-icon-overlap",
      `${MULTI_MP_SLOT_ICON_OVERLAP_PX}px`,
    );
  }
  indicator.setAttribute("aria-hidden", "true");

  const fill = document.createElement("span");
  fill.className = "hover-idle-mp-slot-fill";
  fill.setAttribute("aria-hidden", "true");

  const icons = document.createElement("span");
  icons.className = "hover-idle-mp-slot-icons";
  icons.setAttribute("aria-hidden", "true");

  for (let index = 0; index < iconCount; index += 1) {
    const icon = document.createElement("span");
    icon.className = "hover-idle-mp-slot-icon";
    if (iconCount > 1) {
      icon.dataset.requiredMpIndex = String(index);
    }
    icon.innerHTML = MOUSE_POINTER_ICON_SVG_SOURCE;
    icons.append(icon);
  }

  indicator.append(fill, icons);
  if (options?.pauseOverlay === true) {
    indicator.dataset.paused = "false";
    const pauseOverlay = document.createElement("span");
    pauseOverlay.className = "hover-idle-mp-slot-pause-overlay";
    pauseOverlay.setAttribute("aria-hidden", "true");
    pauseOverlay.innerHTML = pauseIconSource;
    indicator.append(pauseOverlay);
  }
  if (options?.blockedOverlay === true) {
    const blockOverlay = document.createElement("span");
    blockOverlay.className = "hover-idle-mp-slot-block-overlay";
    blockOverlay.setAttribute("aria-hidden", "true");
    blockOverlay.innerHTML = banIconSource;
    indicator.append(blockOverlay);
  }
  return indicator;
}
